import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const getToasts = createSelector(
  (state: RootState) => state.toast,
  toast => toast,
)
